import {
  ButtonState,
  OrderNoticeAdminButton,
  OrderNoticeAdminResponse,
} from '../types/types'

export interface UpdateRedButtonState {
  readonly type: 'UPDATE_RED_BUTTON_STATE'
  readonly newRedButtonState: ButtonState
}

export interface UpdateGreenButtonState {
  readonly type: 'UPDATE_GREEN_BUTTON_STATE'
  readonly newGreenButtonState: ButtonState
}

export interface GreenButtonVirtualServer {
  readonly type: 'GREEN_BUTTON_VIRTUAL_SERVER'
  readonly virtualServerId: string
}

export interface GreenButtonFailed {
  readonly type: 'GREEN_BUTTON_FAILED'
  readonly virtualServerId: string
}

export interface RedButtonVirtualServer {
  readonly type: 'RED_BUTTON_VIRTUAL_SERVER'
  readonly virtualServerId: string
}

export interface OrderNoticeAdminResponseReceived {
  readonly type: 'ORDER_NOTICE_ADMIN_RESPONSE_RECEIVED'
  readonly virtualServerId: string
  readonly message: string
  readonly success: boolean
  readonly button: OrderNoticeAdminButton
}

export interface RedButtonFailed {
  readonly type: 'RED_BUTTON_FAILED'
  readonly virtualServerId: string
}

export function updateRedButtonState(
  newRedButtonState: ButtonState,
): UpdateRedButtonState {
  return {
    newRedButtonState,
    type: 'UPDATE_RED_BUTTON_STATE',
  }
}

export function updateGreenButtonState(
  newGreenButtonState: ButtonState,
): UpdateGreenButtonState {
  return {
    newGreenButtonState,
    type: 'UPDATE_GREEN_BUTTON_STATE',
  }
}

export function greenButtonVirtualServer(virtualServerId: string): GreenButtonVirtualServer {
  return {
    virtualServerId,
    type: 'GREEN_BUTTON_VIRTUAL_SERVER',
  }
}

export function greenButtonFailed(virtualServerId: string): GreenButtonFailed {
  return {
    virtualServerId: virtualServerId,
    type: 'GREEN_BUTTON_FAILED',
  }
}

export function redButtonVirtualServer(virtualServerId: string): RedButtonVirtualServer {
  return {
    virtualServerId,
    type: 'RED_BUTTON_VIRTUAL_SERVER',
  }
}

export function orderNoticeAdminResponseReceived(
  orderNoticeAdminResponse: OrderNoticeAdminResponse,
): OrderNoticeAdminResponseReceived {
  return {
    ...orderNoticeAdminResponse,
    type: 'ORDER_NOTICE_ADMIN_RESPONSE_RECEIVED',
  }
}

export function redButtonFailed(virtualServerId: string): RedButtonFailed {
  return {
    virtualServerId: virtualServerId,
    type: 'RED_BUTTON_FAILED',
  }
}
